import React from 'react'

import { Title } from '@acorns/web-components'
import styled from 'styled-components'

import AcornsLogoSvgPath from 'assets/icons/acorns-logo.svg'
import ChromeLogoSvgPath from 'assets/icons/chrome-logo.svg'
import GreenCheckmarkSvgPath from 'assets/icons/green-checkmark.svg'
import { OAUTH_PARTNER_CONTENT_TITLE } from 'src/utils/testing/testIds'

const ACORNS_EARN_CHROME_EXTENSION_CLIENT_ID =
  '018caeb2cb9e36cbf4937ea2770553a189ff1411c365953b8578519e84c0c0d1'

export const KNOWN_OAUTH_PARTNER_CLIENT_IDS = [
  ACORNS_EARN_CHROME_EXTENSION_CLIENT_ID,
]

const PartnerContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 340px;
  margin-top: 30px;
`

const PartnerContentLogoContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 40px;

  img:first-child {
    margin-right: 50px;
  }
`

const PartnerContentLogo = styled.img`
  height: 60px;
`

const PartnerContentTitle = styled(Title)`
  font-weight: 600;
  font-size: 32px;
  line-height: 37.5px;
  text-align: center;
  color: #000000;
  margin-bottom: 5px;
`

const PartnerContentUnorderedList = styled.ul`
  list-style-type: none;
  list-style-position: outside;
  padding-left: 20px;
  margin-bottom: 15px;
`

const PartnerContentListItem = styled.li`
  background-image: url(${GreenCheckmarkSvgPath});
  background-repeat: no-repeat;
  background-position: left top 6px;
  padding-left: 25px;
  line-height: 25px;
  color: #000000;
  margin-bottom: 10px;
`

// These "partner contents" can be verified by visiting `/oauth?client_id=your_partner_client_id`
function OAuthPartnerContent({ clientId }) {
  switch (clientId) {
    case ACORNS_EARN_CHROME_EXTENSION_CLIENT_ID:
      return (
        <PartnerContentContainer>
          <PartnerContentLogoContainer>
            <PartnerContentLogo src={AcornsLogoSvgPath} alt="Acorns logo" />
            <PartnerContentLogo
              src={ChromeLogoSvgPath}
              alt="Google Chrome logo"
            />
          </PartnerContentLogoContainer>
          <PartnerContentTitle data-testid={OAUTH_PARTNER_CONTENT_TITLE}>
            Your Acorns Earn
            <br />
            Chrome Extension
            <br />
            is ready to go
          </PartnerContentTitle>
          <PartnerContentUnorderedList>
            <PartnerContentListItem>
              Customers have earned over $20,000,000 through Acorns Earn.
            </PartnerContentListItem>
            <PartnerContentListItem>
              Earn from 12,000+ top brands.
            </PartnerContentListItem>
            <PartnerContentListItem>
              Start earning while you shop, now!
            </PartnerContentListItem>
          </PartnerContentUnorderedList>
        </PartnerContentContainer>
      )
    default:
      return null
  }
}

export default OAuthPartnerContent
